import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { formatDateWithoutSeconds, } from "../utils/utils";
import "../analytics/analytics.css";
import TransactionStatusSchema from "../../reusableComponents/TransactionStatusSchema";

export const multiPaymentTransactionListSchema = () => {

    return {
        metadata: {
            title: "Payment Detials",
            minHeight: 500,
            position: "relative",
            rowHeight: 60,
            showTitle: false,
            defaultSortInfo: { name: "addedTimestamp", dir: -1 },
            defaultVisible: [
                "transactionId",
                "timestamp",
                "amount",
                "operationStatus",
            ]
        },
        fields: [
            {
                name: "transactionId",
                header: "Transaction Id",
                visible: true,
                type: "string",
                filtering: false,
                minWidth: 220,
                defaultFlex: 1,
                textAlign: "center",
                sortable: false,
                render: ({ data }) => (
                    <span style={{ marginLeft: "-12px" }}>{data.transactionId}</span>
                ),
            },
            {
                name: "timestamp",
                header: "Created At",
                visible: true,
                type: "string",
                filtering: false,
                minWidth: 200,
                textAlign: "center",
                sortable: false,
                defaultFlex: 1,
                render: ({ data }) => (
                    <span style={{ marginLeft: "-12px" }}>{formatDateWithoutSeconds(data.timestamp)}</span>
                ),
            },
            {
                name: "amount",
                header: "Amount",
                visible: true,
                type: "string",
                filtering: false,
                minWidth: 200,
                defaultFlex: 2,
                textAlign: "start",
                sortable: false,
                render: ({ data }) => (
                    <span style={{ marginLeft: "-12px" }}>{`${data?.currencyCode} ${data?.amountLocaleFull}`}</span>
                ),
            },
            {
                name: "operationStatus",
                header: "Status",
                visible: true,
                type: "string",
                filtering: false,
                minWidth: 270,
                defaultFlex: 1,
                textAlign: "start",
                sortable: false,
                render: ({ value }) => (<TransactionStatusSchema status={value} />)
            },
        ],
    };
};

